module.exports = __webpack_public_path__ + "static/media/mainimg-06.7d25c035.png";